import React from "react";
import {
    BOLETA, calcTotal,
    calculateCotizaciones2,
    formatSoles,
    FACTURA,
    ICBPER,
    IGV,
    NUMBER_KEYS,
    TIPO_STOCK,
    VALE,
    CONTADO,
    CREDITO,
} from "../../Global";
import BuscarClientePorDoc from "../../componentes/Preventas/BuscarClientePorDoc";
import ListaProductosPreventa from "../../componentes/Preventas/ListaProductosPreventa";
import ModalCliente from "../../componentes/clientes/ClienteModal";
import ClienteNuevo from "../../componentes/clientes/ClientesNuevo";
import Modal from "../../componentes/Modal";
import ModalBuscarCliente from "../../componentes/Preventas/ModalBuscarCliente";
import _ from "lodash";
import {
    FindPrecioEspecial,
    FindPrecioFamiliar, FindPrecioMenor,
    FindPrecioPorMayor,
    GetPrecioCosto, getPrecioPorMayor
} from "../../componentes/Preventas/PreciosPreventa";
import {
    setPreciosYDescuento,
    setValorUnitario
} from "../../helpers/calcularVenta";
import $ from "jquery";
import DetalleCotizaciones from "../../componentes/Cotizaciones/DetalleCotizaciones";
import {
    notificationCantidadNegativa,
    notificationNoHayProducto,
} from "../../componentes/Preventas/PreVentaNotify";
import Noty from "noty";
import moment from "moment";
import {notificarError} from "../../componentes/Almacenes/AlmacenNotify";
import {isNumber} from "../../helpers/utils";
import {defaultGetHeaders, pfetch} from "../../helpers/wrappers";
import PreventaModalDescuentos from "../../componentes/Preventas/PreventaModalDescuentos";
import "./styles/CrearCotizaciones.css";
import Select from 'react-select'
import CombosService from "../../services/CombosService";
import matchSorter from "match-sorter";

export default class CrearCotizacion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            Creado: false,
            item: {},
            loading: true,
            error: null,
            buscar: "",
            IdCliente: "",
            dataProductos: {
                productos: []
            },
            Documento: "99999999",
            dataCliente: [],
            modalClienteIsOpen: false,
            totalMonto: 0,
            Gravado: 0,
            Inafecto: 0,
            ICBPERPreventa: 0,
            Exonerado: 0,
            IGVPreventa: 0,
            Gratuitas: 0,
            IVAP: 0,
            ISC: 0,
            cotizacionId: "",
            IdAlmacen: null,
            almacenes: {
                resuts: []
            },
            IdMoneda: 1,
            TasaIGV: IGV,
            TasaICBPER: ICBPER,
            Total: 1,
            IdTipoDocumentoSunat: 4,
            descripcion: "",
            RUSS: "",
            statusModal: false,
            statusModalSearchCliente: false,
            detalles: [],
            searchDisabled: false,
            load: false,
            redondeo: 0,
            afectsIgv: [],
            inputName: "",
            Alias: "",
            idUrlCotizacion: null,
            showDiscountModal: false,
            canAddExtraFields: false,
            tipoPagos: [
                { value: CONTADO, label: 'Contado' },
                { value: CREDITO, label: 'Crédito' }
            ],
            PlazoEntrega: null,
            IdTipoPago: null,

            combos: [],
            filteredCombos: [],
        }

        this.combosService = new CombosService();
        this.getProductos = this.getProductos.bind(this);
        this.handleChangeBuscar = this.handleChangeBuscar.bind(this);
        this.AgregarCantidadDet = this.AgregarCantidadDet.bind(this)
        this.RestarCantidadDet = this.RestarCantidadDet.bind(this)
        this.RemoveProductoInList = this.RemoveProductoInList.bind(this)
        this.PrecioChange = this.PrecioChange.bind(this)
        this.handleOpenModal = this.handleOpenModal.bind(this)
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this)
        this.handleClickBuscar = this.handleClickBuscar.bind(this)
        this.handleCloseBuscar = this.handleCloseBuscar.bind(this)
        this.handleKeyUp = this.handleKeyUp.bind(this)
        this.AsignarValorDoc = this.AsignarValorDoc.bind(this)
        this.handleEnterKeyUp = this.handleEnterKeyUp.bind(this);
        this.onSecretKeyPress = this.onSecretKeyPress.bind(this);
        this.onBlurCantidad = this.onBlurCantidad.bind(this);
        this.onBlurPrecioVenta = this.onBlurPrecioVenta.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.GetCliente = this.GetCliente.bind(this);
        this.handleClickNuevo = this.handleClickNuevo.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.setActiveInputDoc = this.setActiveInputDoc.bind(this);
        this.DocChange = this.DocChange.bind(this);
        this.AliasChange = this.AliasChange.bind(this);
        this.AddProductoInList = this.AddProductoInList.bind(this);
        this.InputCantidadDetalleChange = this.InputCantidadDetalleChange.bind(this);
        this.precioVentaChange = this.precioVentaChange.bind(this);
        this.InputPrecioVentaChange = this.InputPrecioVentaChange.bind(this);
        this.saveCotizacion = this.saveCotizacion.bind(this);
        this.onChangeDiscount = this.onChangeDiscount.bind(this);
        this.onChangeAfectFree = this.onChangeAfectFree.bind(this);
        this.onShowModalDescuento = this.onShowModalDescuento.bind(this);
        this.fetchAfects = this.fetchAfects.bind(this);
        this.verifyPredefinedDiscount = this.verifyPredefinedDiscount.bind(this);
        this.handleCloseAddExtraInfo = this.handleCloseAddExtraInfo.bind(this)
    }

    async componentDidMount() {
        this.getRUSS();
        this.getProductos();
        await this.fetchCombos();
        await this.TraerClientePorDoc(this.state.Documento);

        let id = this.props.match.params.id;

        if (!!id && !isNaN(+id)) {
            const currentPath = window.location.pathname;

            if (currentPath.includes('editar')) {
                this.loadCotizacion(id);
            } else {
                this.newCotizacion().then(() => this.duplicateCotizacion(id)).then(() => this.setState({ Creado: true }))
            }
        }
    }

    async fetchCombos() {
        try {
            const combos = await this.combosService.fetchAll();
            this.setState({ combos });
        } catch (e) {
            console.error(e);
        }
    }

    handleOpenModal() {
        this.setState({
            statusModal: true
        });
    }

    handleOnCloseModal() {
        this.setState({
            statusModal: false
        });
    }

    async onChangeDiscount(e, item, save = false) {
        const items = [...this.state.detalles]
        const i = items.indexOfObject(item, 'IdPresentacion')
        const val = e.target.value
        //console.log({val,i,items,item})
        //console.log({condicionalCambiarDescuento: Number(items[i].Gratuito) === 0})
        if (Number(items[i].Gratuito) === 0) {
            //console.log("descuento")
            items[i].Descuento = val
            if (save) {
                items[i].DescuentoGuardado = val;
            }
            items[i].Total = calcTotal(items[i]) -  Number(items[i].Descuento)
            items[i].total = calcTotal(items[i]) -  Number(items[i].Descuento)
            //console.log({itemModificado : items[i]})
            //this.updateState(items)
            //this.setState({detalles: items});
            this.montoTotalDetalle(items)
            this.setState({detalles: items,selectedItem: items[i]})
            await this.updateDetCotizacion(item)
            await this.updateCotizacion();
        }
    }

    onChangeAfectFree(e, item) {
        let items = [...this.state.payload.detalles];
        let i = items.indexOfObject(item, 'IdPresentacion');
        const val = e.target.value

        const checked = String(val) !== "-1";
        items[i].checked = checked
        items[i].Gratuito = checked ? 1 : 0

        if (checked) {
            items[i].Descuento = 0
            items[i].IdAfectacionIgv = val
        } else
            items[i].IdAfectacionIgv = items[i].initialAfectGrat

        this.updateState(items)
    }

    onShowModalDescuento(item) {
        this.setState({showDiscountModal: true, selectedItem: item})
        this.fetchAfects(item.IdGrupoClasificacionIgv)
    }

    fetchAfects(idAfect) {
        pfetch({
            fetch: {
                url: `/api/preVentas/free-afects?idGrupoIgv=${idAfect}`,
                headers: defaultGetHeaders()
            },
            before: () => this.setState({isLoading: true}),
            then: (d) => this.setState({afectsIgv: d}),
            catch: () => notificarError("Ha ocurrido un error al momento de extraer las afectaciones gratuitas"),
            finally: () => this.setState({isLoading: false})
        })
    }

    async loadCotizacion(id) {
        this.setState({ cotizacionId: id })

        try {
            const response = await fetch(`/api/cotizaciones/detalles/${id}`);
            const data = await response.json();

            const { NroTipoDocumento, idCliente } = data.cot;

            this.setState({
                IdCliente: idCliente,
                Documento: NroTipoDocumento,
            })

            await this.TraerClientePorDoc(NroTipoDocumento);
            
            let detsProd = data.dets.map(dp => ({
                ...dp,
                PrecioVenta: dp.precioVenta,
                IdTipoStock: dp.IdTipoStock,
                Tributos: dp.Tributos,
                TasaISC: dp.TasaISC,
                PrecioEspecial: FindPrecioEspecial([], dp),
                PrecioFamiliar: FindPrecioFamiliar([], dp),
                PrecioCosto: GetPrecioCosto([], dp),
                PrecioMenor: FindPrecioMenor([], dp),
                oldPrecios: [],
                precioMayor: getPrecioPorMayor([], dp),
            }))

            this.montoTotalDetalle(detsProd)
            this.setState({detalles: detsProd})

        } catch (error) {
            this.setState({loading: false, error: error});
        }
    }

    async newCotizacion() {
        this.setState({loading: true, error: null});
        const cotizaIdFromLocalStorage = window.localStorage.getItem('cotizacionId');
        const currentCotizaId = this.state.cotizacionId;

        let cotizaId = cotizaIdFromLocalStorage || currentCotizaId;

        if (cotizaId) {
            this.setState({cotizacionId: cotizaId})
            try {
                const response = await fetch(`/api/cotizaciones/detalles/${cotizaId}`);
                const data = await response.json();
                let detsProd = data.dets.map(dp => ({
                    ...dp,
                    PrecioVenta: dp.precioVenta,
                    IdTipoStock: dp.IdTipoStock,
                    Tributos: dp.Tributos,
                    TasaISC: dp.TasaISC,
                    PrecioEspecial: FindPrecioEspecial([], dp),
                    PrecioFamiliar: FindPrecioFamiliar([], dp),
                    PrecioCosto: GetPrecioCosto([], dp),
                    PrecioMenor: FindPrecioMenor([], dp),
                    oldPrecios: [],
                    precioMayor: getPrecioPorMayor([], dp),
                }))
                this.montoTotalDetalle(detsProd)
                this.setState({detalles: detsProd})
            } catch (error) {
                this.setState({loading: false, error: error});
            }
        } else
            await this.createCotizacion();

    }

    async duplicateCotizacion(id) {
        this.setState({loading: true, error: null});
        try {
            const response = await fetch(`/api/cotizaciones/detalles/${id}`);
            const data = await response.json();
            let detsProd = data.dets.map(dp => ({
                ...dp,
                PrecioVenta: dp.precioVenta,
                IdTipoStock: dp.IdTipoStock,
                Tributos: dp.Tributos,
                TasaISC: dp.TasaISC,
                PrecioEspecial: FindPrecioEspecial([], dp),
                PrecioFamiliar: FindPrecioFamiliar([], dp),
                PrecioCosto: GetPrecioCosto([], dp),
                PrecioMenor: FindPrecioMenor([], dp),
                oldPrecios: [],
                precioMayor: getPrecioPorMayor([], dp),
            }))
            for (const dp of detsProd) {
                await this.addDetCotizacionDuplicate(dp)
            }

            this.montoTotalDetalle(detsProd)
            this.setState({detalles: detsProd})
            await this.updateCotizacion();

        } catch (error) {
            this.setState({loading: false, error: error});
        }
    }

    montoTotalDetalle(items) {
        const itemsTmp = [...items];
        const totales = calculateCotizaciones2(itemsTmp);
        this.setState({
            Gravado: totales.gravados,
            Inafecto: totales.inafectos2,
            Exonerado: totales.exonerados,
            IGVPreventa: totales.igvVenta,
            Gratuitas: totales.gratuitos,
            totalMonto: totales.total,
            ICBPERPreventa: totales.icbper,
            redondeo: 0,

        })
    }

    async createCotizacion() {
        try {
            let res = await fetch("/api/cotizaciones/", {
                method: "POST",
                body: JSON.stringify({
                    IdCliente: this.state.IdCliente,
                    Estado: this.state.Estado,
                    IdMoneda: this.state.IdMoneda,
                    TasaIGV: this.state.TasaIGV,
                    TasaICBPER: this.state.TasaICBPER,
                    Total: this.state.totalMonto,
                    descripcion: this.state.descripcion
                }),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            })

            if (res.ok) {
                let data = await res.json();
                window.localStorage.setItem('cotizacionId', data.id);
                this.setState({cotizacionId: data.id})
            } else
                this.setState({error: "Error en la petición"})

        } catch (error) {
            this.setState({
                loading: false,
                error: error
            });
        }
    }

    handleChangeBuscar(e) {
        this.setState({
            buscar: e.target.value
        });
    }

    async AgregarCantidadDet(item) {
        this.setState({load: true});
        const items = [...this.state.detalles]
        const i = items.indexOf(item)
        items[i].cantidad++
        items[i].Cantidad = items[i].cantidad
        FindPrecioPorMayor([], items[i])
        items[i].total = calcTotal(item, false, 'cantidad', 'precioVenta');
        this.setState({detalles: items})
        this.montoTotalDetalle(items)
        await this.updateDetCotizacion(item)
        await this.updateCotizacion();
        this.setState({load: false});
    }

    async updateCotizacion() {
        try {
            await fetch(`/api/cotizaciones/${this.state.cotizacionId}`, {
                method: "PUT",
                body: JSON.stringify({
                    total: this.state.totalMonto
                }),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            })
        } catch (error) {
            this.setState({loading: false, error: error});
        }
    }

    async updateDetCotizacion(item) {
        try {
            console.log({detalleActualizado:item})
            await fetch(`/api/cotizaciones/detalles/${item.id}`, {
                method: "PUT",
                body: JSON.stringify({
                    idCotizacion: item.idCotizacion,
                    cantidad: item.cantidad,
                    total: item.total,
                    descuento: item.Descuento? item.Descuento : 0,
                    precioVenta: item.precioVenta,
                    valorUnitario: item.valorUnitario,
                    idAfectacionIgv: item.idAfectacionIgv,
                }),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            })
        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    }

    async getRUSS() {
        this.setState({loading: true, error: null});
        try {
            const response = await fetch(`/api/preVentas/getEmpresaByUser`);
            const data = await response.json();
            this.setState({RUSS: data[0].EsRuss})
        } catch (error) {
            this.setState({loading: false, error: error});
        }
    }

    async getProductos(idTipoStock = TIPO_STOCK.CON_COMPROBANTE, query = '') {
        this.setState({loading: true, error: null});

        try {
            const response = await fetch(`/api/preVentas/?search=${query}&idTipoStock=${idTipoStock}`);
            const data = await response.json();
            this.setState({
                loading: false,
                dataProductos: data,
            });
            await this.TributosInProductos(this.state.dataProductos.productos)
        } catch (error) {
            this.setState({loading: false, error: error});
            console.log("getProductos error: ", error)
        }
    }

    async TraerClientePorDoc(DNI) {
        try {
            await fetch(`/api/preVentas/traerCliente/${DNI}`)
                .then(res => res.json())
                .then(data => {

                    this.setState({
                        loading: false,
                        dataCliente: data[0] ? data[0] : 0,
                        IdCliente: data[0] ? data[0].IdCliente : 0,
                        StockPorCliente: []
                    });
                    if (data[0]) {
                        if (this.state.RUSS === "Inactivo") {
                            if (this.state.IdTipoDocumentoSunat !== VALE) {
                                if (data[0].IdTipoDocumento === 1 || data[0].IdTipoDocumento === 7) {
                                    this.setState({
                                        IdTipoDocumentoSunat: BOLETA,
                                        filtroTipoStock: 1,
                                        checkfiltroTipoStock: true
                                    })
                                } else {
                                    this.setState({
                                        IdTipoDocumentoSunat: FACTURA,
                                        filtroTipoStock: 1,
                                        checkfiltroTipoStock: true
                                    })
                                }
                            }
                        }
                    }
                });

        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    }

    async AddProductoInList(item, descuentoPredefinido = null, cantidad = 1) {
        this.setState({load: true});
        $("#InputBuscarProd").focus();
        let detalles = [...this.state.detalles];
        let tmpDetails = [];
        let itemFounded = detalles.find(i => (String(i.IdPresentacion) === String(item.IdPresentacion)));

        if (itemFounded) {
            const oldQuantity = itemFounded.Cantidad || itemFounded.cantidad;
            const oldDescuento = itemFounded.Descuento;
            const perUnitDescuento = oldDescuento / oldQuantity;
            itemFounded.cantidad = itemFounded.cantidad + cantidad;
            itemFounded.Cantidad = itemFounded.cantidad;
            itemFounded.Descuento = perUnitDescuento * itemFounded.Cantidad;
            FindPrecioPorMayor([], itemFounded)
            itemFounded.total = calcTotal(itemFounded, false, 'cantidad', 'precioVenta') - itemFounded.Descuento
        } else {
            tmpDetails = detalles.map(dp => ({
                ...dp,
                cantidad: dp.cantidad,
                Cantidad: dp.Cantidad,
                Descuento: dp.Descuento,
                precioVenta: dp.precioVenta,
                total: dp.total,
                id: dp.id,
                idStock: dp.IdStock,
                Tributos: dp.Tributos,
                PrecioEspecial: FindPrecioEspecial([], dp),
                PrecioFamiliar: FindPrecioFamiliar([], dp),
                PrecioCosto: GetPrecioCosto([], dp),
                PrecioMenor: FindPrecioMenor([], dp),
                precioMayor: getPrecioPorMayor([], dp),
                oldPrecios: dp.oldPrecios,
                idPresentacion: dp.IdPresentacion,
                tipoCambio: dp.TipoCambio,
                initialAfectGrat: item.idAfectacionIgv,
                idAlmacen: dp.IdAlmacen,
                idAfectacionIgv: dp.IdAfectacionIgv,
                valorUnitario: dp.ValorUnitario,
            }))
            FindPrecioPorMayor([], item)

            const detail = {
                ...item,
                cantidad: cantidad,
                Cantidad: cantidad,
                Descuento: !!descuentoPredefinido ? descuentoPredefinido * cantidad : item.Descuento,
                precioVenta: item.precioVenta,
                total: item.precioVenta,
                id: "",
                idStock: item.IdStock,
                Tributos: item.Tributos,
                idPresentacion: item.IdPresentacion,
                PrecioEspecial: FindPrecioEspecial([], item),
                PrecioFamiliar: FindPrecioFamiliar([], item),
                PrecioCosto: GetPrecioCosto([], item),
                PrecioMenor: FindPrecioMenor([], item),
                precioMayor: getPrecioPorMayor([], item),
                oldPrecios: [item.precioVenta],
                initialAfectGrat: item.idAfectacionIgv,
                tipoCambio: item.TipoCambio,
                idAlmacen: item.IdAlmacen,
                idAfectacionIgv: item.IdAfectacionIgv,
                valorUnitario: item.ValorUnitario,
            }

            detail.total = calcTotal(detail, false, 'cantidad', 'precioVenta') - detail.Descuento;

            const detailHandler = {
                set(target, property, value) {
                    if (property == 'Cantidad') {
                        const cantidad = +value;
                        let perUnitDescuento = 'DescuentoGuardado' in target ? target['DescuentoGuardado'] : 0;

                        if (cantidad > 0) {
                            const oldQuantity = target.Cantidad;

                            if (oldQuantity > 0) {
                                const oldDescuento = target.Descuento;
                                perUnitDescuento = oldDescuento / oldQuantity;
                            }
                        }

                        target[property] = cantidad;
                        target["Descuento"] = cantidad * perUnitDescuento;
                        target['total'] = calcTotal(target, false, 'cantidad', 'precioVenta') - target['Descuento'];
                    } else {
                        target[property] = value;
                    }

                    return true;
                }
            }

            const detailProxy = new Proxy(detail, detailHandler)
            tmpDetails.push(detailProxy)
        }

        let dets = itemFounded ? detalles : tmpDetails;
        let targetItem = itemFounded ? itemFounded : tmpDetails[tmpDetails.length - 1];

        this.montoTotalDetalle(dets)

        this.setState({detalles: dets, load: false, buscar: this.state.cleanSearch ? '' : this.state.buscar, searchDisabled: false,})

        if (itemFounded)
            await this.updateDetCotizacion(targetItem)
        else
            await this.addDetCotizacion(targetItem)
        
        await this.updateCotizacion();

        //console.log({targetItem,detalles,dets})
        this.setState({load: false, buscar: '', detalles: dets});

        if (!itemFounded) {
            if (descuentoPredefinido == null) {
                this.verifyPredefinedDiscount(targetItem);
            }
        }
    }

    async verifyPredefinedDiscount(item) {
        const idPresentacion = item.IdPresentacion;

        const req = await fetch(`/api/presentaciones/${idPresentacion}/descuento-predefinido?validate=true`);

        if (!req.ok) {
            return;
        }

        const data = await req.json();

        this.onChangeDiscount({
            target: { value: data.Descuento }
        }, item);
    }

    async addDetCotizacion(item) {
        if (!this.state.Creado) {
            await this.newCotizacion()
            this.setState({ Creado: true })
        }

        //console.log(item)
        try {
            console.log({itemParaAgregarDetalle: item})
            let res = await fetch("/api/cotizaciones/detalles", {
                method: "POST",
                body: JSON.stringify({
                    idCotizacion: this.state.cotizacionId,
                    cantidad: item.cantidad,
                    total: item.total,
                    idStock: item.idStock,
                    idPresentacion: item.idPresentacion,
                    descuento: item.Descuento? item.Descuento : 0.0,
                    idAfectacionIgv: item.idAfectacionIgv,
                    precioVenta: item.precioVenta,
                    tipoCambio: item.tipoCambio,
                    idAlmacen: item.idAlmacen,
                    valorUnitario: item.valorUnitario
                }),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            })

            let data = await res.json()
            item.id = data.id;
            item.idCotizacion = this.state.cotizacionId
            let detsItem = [...this.state.detalles];
            let index = detsItem.indexOf(detsItem);
            detsItem[index] = item
            this.setState({detalles: detsItem})

        } catch (error) {
            this.setState({
                loading: false,
                error: error
            });
        }
    }

    async   addDetCotizacionDuplicate(item) {
        //console.log({item})
        try {
            let res = await fetch("/api/cotizaciones/detalles", {
                method: "POST",
                body: JSON.stringify({
                    idCotizacion: this.state.cotizacionId,
                    cantidad: item.cantidad,
                    total: item.total,
                    idStock: item.idStock,
                    descuento: item.Descuento? item.Descuento : 0,
                    idPresentacion: item.idPresentacion,
                    idAfectacionIgv: item.idAfectacionIgv,
                    precioVenta: item.precioVenta,
                    tipoCambio: item.tipoCambio,
                    idAlmacen: item.idAlmacen,
                    valorUnitario: item.valorUnitario
                }),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            })

            let data = await res.json()
            item.id = data.id;
            item.idCotizacion = this.state.cotizacionId
            let detsItem = [...this.state.detalles];
            let index = detsItem.indexOf(detsItem);
            detsItem[index] = item
            this.setState({detalles: detsItem})

        } catch (error) {
            this.setState({
                loading: false,
                error: error
            });
        }
    }

    DocChange(e) {
        this.setState({
            Documento: e.target.value
        }, () => {
            if (this.state.Documento.length === 8 ||
                this.state.Documento.length === 11 ||
                this.state.Documento.length === 9) {
                this.TraerClientePorDoc(this.state.Documento)

            }
        });
    }

    setActiveInputDoc(e, inputName) {
        e.target.select()
        this.setState({
            inputName: inputName
        });
    }

    handleClickNuevo() {
        this.setState({
            modalClienteIsOpen: true,
            itemcliente: {
                ...this.state.itemcliente,
                idcliente: null,
            }
        })
    }

    handleClickBuscar() {
        this.setState({
            statusModalSearchCliente: true
        })
    }

    handleCloseBuscar() {
        this.setState({
            statusModalSearchCliente: false
        })
    }

    handleCloseAddExtraInfo() {
        this.setState({
            canAddExtraFields: false
        })
    }

    AliasChange(e) {
        this.setState({
            Alias: e.target.value
        });
    }

    async handleEnterKeyUp(e) {
        const tipoStock = TIPO_STOCK.CON_COMPROBANTE;
        if (e.key === "Enter") {
            this.setState({searchDisabled: true})
            await this.getProductos(tipoStock, this.state.buscar);
            this.setState({searchDisabled: false})
            const productos = this.state.dataProductos.productos;
            if (productos.length === 1) {
                this.AddProductoInList(productos[0])
                this.setState({
                    buscar: "",
                    searchDisabled: false
                })
            } else {
                this.setState({
                    buscar: "",
                    searchDisabled: false
                })
                notificationNoHayProducto()
            }
            this.getProductos(tipoStock, this.state.buscar);
        } else {
            this.getProductos(tipoStock, this.state.buscar);
        }

        const filteredCombos = matchSorter(this.state.combos, this.state.buscar, { keys: ["Nombre", "CodigoBarras"] });
        this.setState({ filteredCombos })
    }

    handleChange(e) {
        this.setState({
            buscar: e.target.value
        });
    }

    onSecretKeyPress(event, detItem) {
        if (event.ctrlKey && event.shiftKey && event.which === NUMBER_KEYS.THREE_NUMBER_KEY)
            this.findPrecioUnitario(detItem, detItem.precio, "Mayor")
    }

    async findPrecioUnitario(item, value, precioSelectedText) {
        this.setState({load: true});
        await this.selectPrecioChange(item, value, precioSelectedText)
        this.setState({load: false});
    }

    async selectPrecioChange(item, value, precioSelectedText) {
        let listaItems = [...this.state.detalles]
        const key = listaItems.indexOf(item)
        let newItem = listaItems[key];
        const precio = item.precios.find(p => p.NombrePrecio.includes(precioSelectedText));

        newItem.precio = precio ? precio.Precio : 0
        newItem.precioVenta = precio ? precio.Precio : 0
        newItem.valorUnitario = precio ? precio.ValorUnitario : 0;
        newItem.total = calcTotal({Cantidad: listaItems[key].cantidad, PrecioVenta: newItem.precioVenta})
        listaItems[key] = newItem;

        this.setState({detalles: listaItems})
        await this.montoTotalDetalle(listaItems)
        await this.updateDetCotizacion(listaItems[key])
        await this.updateCotizacion();
    }

    PrecioChange(e, item) {
        this.findPrecioUnitario(item, e.target.value, e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text)
    }

    InputCantidadDetalleChange(event, item) {
        const items = [...this.state.detalles]
        const i = items.indexOf(item)
        const value = isNumber(event.target.value) ? event.target.value : 1;
        if (value >= 0) {
            items[i].cantidad = items[i].IdUnidad === 58 || items[i].IdUnidad === 59 ? parseInt(value) : value;
            items[i].Cantidad = items[i].cantidad
            FindPrecioPorMayor([], items[i])
            items[i].total = calcTotal(items[i], false, 'cantidad', 'precioVenta')
            this.setState({detalles: items});
            this.montoTotalDetalle(items);
        } else
            notificationCantidadNegativa()
    }

    InputPrecioVentaChange(event, item) {
        this.precioVentaChange(event.target.value, item)
    }

    precioVentaChange(val, item) {
        const listaItems = [...this.state.detalles]
        const key = listaItems.indexOf(item)
        const value = val;
        const itemcalculo = this.getItemCalculo(item);

        listaItems[key].oldPrecios.push(listaItems[key].precioVenta);
        listaItems[key].precioVenta = value
        listaItems[key].valorUnitario = setValorUnitario(itemcalculo)
        listaItems[key].total = calcTotal(listaItems[key], false, 'cantidad', 'precioVenta')
        this.setState({detalles: listaItems})
    }

    getItemCalculo(item) {
        return {
            "PrecioVenta": item.PrecioVenta,
            "Tributos": item.Tributos,
            "TasaISC": item.TasaISC,
            "Cantidad": item.cantidad,
            "Gratuito": item.Gratuito,
            "Descuento": item.Descuento
        }
    }

    async RestarCantidadDet(item) {
        this.setState({load: true});

        const items = [...this.state.detalles]
        const i = items.indexOf(item)

        if (items[i].cantidad > 1) {
            items[i].cantidad--
            items[i].Cantidad = items[i].cantidad
            items[i].total = calcTotal(items[i], false, 'cantidad', 'precioVenta')

            this.setState({detalles: items})
            this.montoTotalDetalle(items)
            await this.updateDetCotizacion(item)
            await this.updateCotizacion();
        }
        this.setState({load: false});
    }

    async RemoveProductoInList(item) {
        this.setState({load: true});

        let detsVenta = [...this.state.detalles];
        detsVenta.splice(detsVenta.indexOf(item), 1)
        this.setState({detalles: detsVenta})

        this.montoTotalDetalle(detsVenta)
        await this.removeDetCotizacion(item)
        await this.updateCotizacion();
        this.setState({load: false});
    }

    async removeDetCotizacion(item) {
        this.setState({loading: true, error: null});
        try {
            await fetch(`/api/cotizaciones/detalles/${item.id}`, {
                method: "DELETE",
                headers: {Accept: "application/json"}
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error
            });
        }
    }

    async onBlurCantidad(e, item) {
        this.setState({load: true});
        await this.updateCotizacion();
        await this.updateDetCotizacion(item)
        this.setState({load: false});
    }

    async onBlurPrecioVenta(e, item) {
        const {value} = e.target;
        if (value < item.PrecioCosto) {
            new Noty({
                type: "warning",
                theme: "bootstrap-v4",
                layout: "topCenter",
                text: `El precio ingresado es menor al precio de costo`,
                timeout: 1500
            }).show()
            let precio = item.oldPrecios.reverse().find(g => Number(g) >= Number(item.PrecioCosto));
            this.precioVentaChange(precio || item.PrecioCosto, item)
        } else {
            this.setState({load: true});
            this.montoTotalDetalle(this.state.detalles)
            await this.updateDetCotizacion(item);
            await this.updateCotizacion();
            this.setState({load: false});
        }
    }

    AsignarValorDoc(dataCliente) {
        this.setState({
            Documento: dataCliente.NroTipoDocumento
        })
        this.TraerClientePorDoc(dataCliente.NroTipoDocumento)
    }

    handleCloseModal() {
        this.setState({modalClienteIsOpen: false})
    }

    handleKeyUp(event) {
        if (event.key === "Escape" || event.key === "Enter") {
            this.setState({
                statusModal: false,
                statusModalDescuento: false
            });
        }
    }

    GetCliente(cliente) {
        this.handleCloseBuscar()
        this.setState({
            Documento: cliente.NroTipoDocumento
        })
        this.TraerClientePorDoc(cliente.NroTipoDocumento)
    }

    async TributosInProductos(prods) {
        let productos = [...prods];
        for (let i = 0; i < productos.length; i++) {
            const itemCalculado = setPreciosYDescuento(productos[i])
            productos[i].Precio = itemCalculado.PrecioVenta
            productos[i].precioVenta = itemCalculado.PrecioVenta
            productos[i].Gratuito= parseInt(itemCalculado.Gratuito)
        }
        //console.log({productos})
        this.setState({dataProductos: {productos: productos}})
    }

    async saveCotizacion(skipValidation = false) {
        if (!skipValidation) {
            const resCotizacion = await fetch(`/api/cotizaciones/${this.state.cotizacionId}`);

            if (resCotizacion.ok) {
                const cotizacion = await resCotizacion.json();

                if (!cotizacion.estado) {
                    this.setState({ canAddExtraFields: true });
                }

                return;
            }
        }

        let payload = {
            estado: "GENERADO",
            fechaEmision: moment(new Date()).format("YYYY-MM-DD HH:mm"),
            descripcion: this.state.Alias || "",
            idCliente: this.state.IdCliente,
            plazoEntrega: this.state.PlazoEntrega,
            idTipoPago: this.state.IdTipoPago
        }
        let res = await fetch(`/api/cotizaciones/update/${this.state.cotizacionId}`, {
            method: "PUT",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        })
        if (res.ok) {
            window.localStorage.removeItem('cotizacionId')
            this.props.history.push("/cotizaciones")
        } else
            notificarError("No se pudo actualizar la cotización.")
    }

    render() {
        const productos = this.state.dataProductos.productos;
        const {afectsIgv} = this.state

        return (
            <React.Fragment>
                <div className="w-100 d-block position-relative d-md-flex responsive-height">
                    <div className="w-100 w-md-50 d-md-flex flex-column px-3 mt-2">
                        <BuscarClientePorDoc
                            goBack={this.props.history.goBack}
                            DocChange={this.DocChange}
                            Documento={this.state.Documento}
                            setActiveInputDoc={this.setActiveInputDoc}
                            TraerClientePorDoc={this.TraerClientePorDoc}
                            dataCliente={this.state.dataCliente}
                            handleClickNuevo={this.handleClickNuevo}
                            handleClickBuscar={this.handleClickBuscar}
                            handleCloseBuscar={this.handleCloseBuscar}
                            Alias={this.state.Alias}
                            placeholder={"Descripción/Observación"}
                            aliasAsText={true}
                            AliasChange={this.AliasChange}
                        />
                        <div className="row ml-0 mr-0">
                            <div
                                className="col-12 col-lg-8 preventa__cliente2 ml-0 espacio-movil caja-fondo-blanco-m-2 letra-movil"
                                style={{
                                    paddingTop: "10px",
                                    paddingBottom: "10px",
                                    borderRadius: "15px 0 0 15px",
                                    boxShadow: "none"
                                }}>
                                {
                                    (this.state.dataCliente.IdTipoDocumento) ?
                                        this.state.dataCliente.RazonSocial || ""
                                        : "CLIENTE NO REGISTRADO"
                                }
                            </div>
                        </div>

                        <div className="w-100">
                            <input
                                type="text"
                                id="InputBuscarProd"
                                placeholder="Buscar Producto"
                                className="caja-fondo-blanco-m-2 borde-15 w-100 mr-2"
                                onKeyUp={this.handleEnterKeyUp}
                                disabled={this.state.searchDisabled}
                                value={this.state.buscar}
                                onChange={this.handleChange}
                                autoFocus/>
                        </div>

                        <div className="h-100 flex-grow-1 overflow-auto mb-3  mobile-max-height">
                            <ListaProductosPreventa
                                load={this.state.load}
                                productos={productos}
                                showStock={true}
                                combos={this.state.buscar != "" ? [] : this.state.filteredCombos}
                                AddProductoInList={this.AddProductoInList}
                                checkedTipoStock={true}
                            />
                        </div>
                    </div>

                    <div className="w-100 w-md-50 d-md-flex px-3 mt-2" style={{overflowY: 'scroll'}}>
                        <DetalleCotizaciones
                            load={this.state.load}
                            conStockChecked={true}
                            detalles={this.state.detalles}
                            onSecretKeyPress={this.onSecretKeyPress}
                            venderConListaPrecios={true}
                            PrecioChange={this.PrecioChange}
                            InputCantidadDetalleChange={this.InputCantidadDetalleChange}
                            InputPrecioVentaChange={this.InputPrecioVentaChange}
                            RestarCantidadDet={this.RestarCantidadDet}
                            AgregarCantidadDet={this.AgregarCantidadDet}
                            RemoveProductoInList={this.RemoveProductoInList}
                            onBlurInputCantidad={this.onBlurCantidad}
                            onBlurPrecioVenta={this.onBlurPrecioVenta}
                            idCotizacion={this.state.idUrlCotizacion}
                            handleOpenModalDescuento={this.onShowModalDescuento}
                        />
                    </div>

                    <ModalCliente isOpen={this.state.modalClienteIsOpen} onClose={this.handleCloseModal}
                                    title="NUEVO CLIENTE">
                        <ClienteNuevo onClose={this.handleCloseModal}
                                        NumeroDocumento={this.state.Documento}
                                        AsignarValorDoc={this.AsignarValorDoc}
                        />
                    </ModalCliente>

                    <Modal
                        isOpen={this.state.statusModalSearchCliente}
                        onClose={this.handleCloseBuscar}
                        handleKeyUp={this.handleKeyUp}
                    >
                        <ModalBuscarCliente
                            GetCliente={this.GetCliente}
                        />
                    </Modal>

                    <Modal
                        title="Agregar información"
                        isOpen={this.state.canAddExtraFields}
                        onClose={this.handleCloseAddExtraInfo}
                    >
                        <React.Fragment>
                            <div className="d-block p-relative mx-3 mt-3 mb-2">
                                <div className="form-group">
                                    <label>Tipo de pago</label>
                                    <Select 
                                        options={this.state.tipoPagos}
                                        isClearable={true}
                                        placeholder={"Seleccione tipo de pago"}
                                        onChange={e => this.setState({ IdTipoPago: !!e ? e.value : null }) }
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Plazo de entrega</label>
                                    <input type="date"
                                        className="input__linea"
                                        min={moment().format("YYYY-MM-DD")}
                                        value={moment(this.state.PlazoEntrega).format("YYYY-MM-DD")}
                                        onChange={(e) =>this.setState({ PlazoEntrega: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="d-block p-relative mt-2 mb-3 text-center">
                                <button className="btn btn-verde-mfp mx-3"
                                        onClick={() => this.saveCotizacion(true)}>
                                    Crear
                                </button>
                            </div>
                        </React.Fragment>
                    </Modal>

                    <Modal title="Realizar descuento" isOpen={this.state.showDiscountModal}
                            onClose={() => this.setState({showDiscountModal: false})}>
                        {this.state.isLoading ?
                            <div className="d-flex justify-content-center">
                                <div className="spinner-border" role="status"/>
                            </div> :
                            <PreventaModalDescuentos
                                load={this.state.isLoading}
                                ItemDescuento={this.state.selectedItem}
                                DescuentoChange={this.onChangeDiscount}
                                onBlurDescuento={() => {
                                }}
                                afectsIgv={afectsIgv}
                                onChangeCheckBoxGratuito={this.onChangeAfectFree}
                            />
                        }
                    </Modal>
                </div>

                <div className="d-none d-md-flex justify-content-between mx-2" style={{ height: '100px', backgroundColor: '#b2c3c0' }}>
                    <div className="d-none d-md-flex justify-content-around w-100 align-items-center">
                        {(this.state.Gravado) > 0 ?
                            <div className="col-sm-auto">
                                <p>
                                    Gravado{" "}
                                    <strong>
                                        {formatSoles(this.state.Gravado)}
                                    </strong>
                                </p>
                            </div>
                            : null
                        }

                        {(this.state.Inafecto) > 0 ?
                            <p>
                                Inafecto{" "}
                                <strong>
                                {formatSoles(this.state.Inafecto)}
                                </strong>
                            </p>
                            : null
                        }
                        {(this.state.Exonerado) > 0 ?
                            <p>
                                Exonerado{" "}
                                <strong>
                                    {formatSoles(this.state.Exonerado)}
                                </strong>
                            </p>
                            : null
                        }
                        {(this.state.Gratuitas) > 0 ?
                            <p>
                                Gratuitas{" "}
                                <strong>
                                    {formatSoles(this.state.Gratuitas)}
                                </strong>
                            </p>
                            : null
                        }
                        {(this.state.ICBPERPreventa) > 0 ?
                            <p>
                                ICBPER{" "}
                                <strong>
                                    {formatSoles(this.state.ICBPERPreventa)}
                                </strong>
                            </p>
                            : null
                        }
                        {(this.state.IGVPreventa) > 0 ?
                            <p>
                                IGV{" "}
                                <strong>
                                    {formatSoles(this.state.IGVPreventa)}
                                </strong>
                            </p>
                            : null
                        }
                        {(this.state.redondeo) > 0 ?
                            <p>
                                Redondeo <strong>
                                {formatSoles(this.state.redondeo)}
                            </strong>
                            </p>
                            : null
                        }

                    </div>
                    <div className="d-block d-md-flex justify-content-center align-items-center w-25 text-white" style={{ backgroundColor: '#01a59c', borderRadius: '15px', minWidth: '50px' }}>
                        <span style={{ fontSize: '3vw' }}>{ formatSoles(this.state.totalMonto)}</span>
                    </div>
                    <div className="d-block d-md-flex justify-content-end align-items-center w-100 pt-1 mr-5">
                        <button
                            disabled={!(_.isNull(this.state.error) || _.isEmpty(this.state.error) || _.isUndefined(this.state.error))}
                            style={{ backgroundColor: '#034b2f', borderRadius: '15px', boxShadow: '0 12px 24px 0 rgba(3,75,47,.6)' }}
                            className="w-25 h-100 text-white font-weight-bold h2 p-0 px-3"
                            type="submit"
                            onClick={() => this.saveCotizacion()}
                        >
                            Guardar
                            {_.isNull(this.state.error) || _.isEmpty(this.state.error) || _.isUndefined(this.state.error) ? "" : "Ah ocurrido un error"}
                        </button>
                    </div>
                </div>

                <div className="d-block d-md-none position-relative pt-2" style={{ backgroundColor: '#b2c3c0' }}>
                    <div className="d-block text-center">
                        {(this.state.Gravado) > 0 ?
                            <div className="col-sm-auto">
                                <p>
                                    Gravado{" "}
                                    <strong>
                                        {formatSoles(this.state.Gravado)}
                                    </strong>
                                </p>
                            </div>
                            : null
                        }

                        {(this.state.Inafecto) > 0 ?
                            <p>
                                Inafecto{" "}
                                <strong>
                                { formatSoles(this.state.Inafecto)}
                                </strong>
                            </p>
                            : null
                        }
                        {(this.state.Exonerado) > 0 ?
                            <p>
                                Exonerado{" "}
                                <strong>
                                    {formatSoles(this.state.Exonerado)}
                                </strong>
                            </p>
                            : null
                        }
                        {(this.state.Gratuitas) > 0 ?
                            <p>
                                Gratuitas{" "}
                                <strong>
                                    {formatSoles(this.state.Gratuitas)}
                                </strong>
                            </p>
                            : null
                        }
                        {(this.state.ICBPERPreventa) > 0 ?
                            <p>
                                ICBPER{" "}
                                <strong>
                                    {formatSoles(this.state.ICBPERPreventa)}
                                </strong>
                            </p>
                            : null
                        }
                        {(this.state.IGVPreventa) > 0 ?
                            <p>
                                IGV{" "}
                                <strong>
                                    {formatSoles(this.state.IGVPreventa)}
                                </strong>
                            </p>
                            : null
                        }
                        {(this.state.redondeo) > 0 ?
                            <p>
                                Redondeo <strong>
                                { formatSoles(this.state.redondeo)}
                            </strong>
                            </p>
                            : null
                        }

                    </div>
                    <div className="d-block w-100 text-white text-center mx-3" style={{ backgroundColor: '#01a59c', borderRadius: '15px'}}>
                        <span style={{ fontSize: '20px' }}>{ formatSoles(this.state.totalMonto)}</span>
                    </div>
                    <div className="d-block w-100 text-white text-center mx-3 mt-2">
                        <button
                            disabled={!(_.isNull(this.state.error) || _.isEmpty(this.state.error) || _.isUndefined(this.state.error))}
                            type="submit"
                            className="w-100 h-100 text-white font-weight-bold h2 p-0 px-3"
                            style={{ backgroundColor: '#034b2f', borderRadius: '15px', boxShadow: '0 12px 24px 0 rgba(3,75,47,.6)' }}
                            onClick={() => this.saveCotizacion()}
                        >
                            Crear
                            {_.isNull(this.state.error) || _.isEmpty(this.state.error) || _.isUndefined(this.state.error) ? "" : "Ah ocurrido un error"}
                        </button>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
